import React, { useEffect } from "react";
import { FilledButton } from "../../common/buttons/FilledButton";
import { SimpleButton } from "../../common/buttons/SimpleButton";
import { CheckCircleIcon } from "@heroicons/react/24/outline";
import { useSubscriptionDeactivation } from "../../../../hooks/contracts/subscriptions/SubscriptionDeactivationHook";
import { translations } from "../../../../utils/translations/translations-manager";

const errorMessages: Record<'deactivation_error', () => string> = {
  deactivation_error: () => translations.texts.deactive_subscription_error.toString()
}

export function SubscriptionDeactivation({ charityId, contractId, success, complete, cancel }: { charityId: string, contractId: string, success: () => void, complete: () => void, cancel: () => void }): JSX.Element {
  const { deactivate, error, clearError, state } = useSubscriptionDeactivation(charityId, contractId)

  useEffect(() => {
    if (state === 'success') complete()
  }, [state])

  if (error) {
    return <><p className="mb-5 text-red-500">{errorMessages[error]()}</p><FilledButton onClick={() => { clearError() }} label={translations.texts.retry.toString()} /></>
  }

  if (state === 'success') {
    return <><div className="flex flex-col items-center justify-center"><CheckCircleIcon className="mr-2 mb-2 w-12 h-12 stroke-emerald-500" /><p className="mb-5">{translations.texts.deactive_subscription_success.toString()}</p></div><FilledButton onClick={success} label={translations.texts.close.toString()} /></>
  }

  return (
    <>
      <div className="px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
        <p className="mb-5">{translations.texts.deactive_subscription_confirm.toString()}</p>
      </div>
      <div className="px-4 py-3 sm:flex sm:flex-row-reverse sm:px-6">
        <FilledButton className='bg-red-500' onClick={deactivate} label={translations.texts.confirm.toString()} loading={state === 'loading'} />
        <SimpleButton onClick={cancel} label={translations.texts.cancel.toString()} disabled={state === 'loading'} />
      </div>
    </>
  )
}